import type { SVGProps } from 'react';
const Package = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={32}
        height={33}
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="Package">
            <path
                id="Vector"
                d="M28.7375 9.35043C28.7342 9.35043 28.731 9.34912 28.7287 9.34677C28.7263 9.34443 28.725 9.34125 28.725 9.33793C28.5443 9.03033 28.2856 8.77591 27.975 8.60043L16.975 2.41293C16.677 2.24654 16.3413 2.15918 16 2.15918C15.6587 2.15918 15.323 2.24654 15.025 2.41293L4.02501 8.60043C3.71441 8.77591 3.45568 9.03033 3.27501 9.33793C3.27501 9.34125 3.27369 9.34443 3.27135 9.34677C3.269 9.34912 3.26582 9.35043 3.26251 9.35043V9.37543C3.08969 9.66667 2.99898 9.99928 3.00001 10.3379V22.6629C3.00064 23.0193 3.09587 23.369 3.27595 23.6765C3.45604 23.984 3.71453 24.2381 4.02501 24.4129L15.025 30.6004C15.3019 30.7515 15.6098 30.837 15.925 30.8504H16.1C16.4072 30.8368 16.707 30.7512 16.975 30.6004L27.975 24.4129C28.2855 24.2381 28.544 23.984 28.7241 23.6765C28.9042 23.369 28.9994 23.0193 29 22.6629V10.3379C29.0018 9.99129 28.9112 9.65042 28.7375 9.35043ZM16 4.15043L25.9625 9.75043L22.1375 11.9254L12.05 6.36293L16 4.15043ZM16.1125 15.3504L6.05001 9.75043L10 7.52543L20.1 13.0879L16.1125 15.3504ZM17.0125 28.2879L17.1125 17.0879L21.125 14.8004V19.5629C21.125 19.8281 21.2304 20.0825 21.4179 20.27C21.6054 20.4576 21.8598 20.5629 22.125 20.5629C22.3902 20.5629 22.6446 20.4576 22.8321 20.27C23.0197 20.0825 23.125 19.8281 23.125 19.5629V13.6629L27 11.4629V22.6629L17.0125 28.2879Z"
                fill="#FDC800"
            />
        </g>
    </svg>
);
export default Package;
